import Auth from '@/bootstrap/auth/auth'

export class JwtAuth extends Auth {
  /**
   * 登入
   */
  async _loginApi (params) {
    const { data } = await request('login', params)
    return {
      token: data.access_token,
      tokenType: data.token_type,
      expiresIn: data.expires_in,
    }
  }

  /**
   * 登出
   */
  async _logoutApi () {
    await request.dispatch('logout')
  }

  /**
   * 登出
   */
  async _meApi () {
    return (await request('getMe')).data
  }

  /**
   * 刷新Token
   */
  async _refreshApi () {
    const { data } = await request('refresh')
    return {
      token: data.access_token,
      tokenType: data.token_type,
      expiresIn: data.expires_in,
    }
  }
}

export default JwtAuth
